Apt.fn.make('advertise', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;
		const priv = scope.$private;

		$$('advertisePost').on('click', () => {
			Apt.auth.prompt(() => {
				$.history.go('/account/listings/create');
			});
		}, {
			cancel: true,
			namespace: 'advertise'
		});

		priv.initPricing();
		priv.initModals();
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('advertise', this);
	}
}, {
	/**
	 * Initialize pricing
	 */
	initPricing() {
		const $basicCost = $$('advertiseBasicCost');
		const $basicLabel = $$('advertiseBasicLabel');
		const $basicNote = $$('advertiseBasicNote');
		const label = $basicLabel.text();
		const note = $basicNote.text();

		$$('advertiseBasicCount').on('input', (e, el) => {
			const count = Number(el.value);

			if (! count) {
				$basicNote.text(note);
			} else {
				$basicNote.text('One-time fee — no ongoing cost');
			}

			if (count === 50) {
				$basicCost.text('—');
				$basicLabel.text('Contact us for volume pricing');
			} else {
				$basicCost.text(count * 10);

				if (! count) {
					$basicLabel.text(label);
				} else {
					$basicLabel.text((count + 1) + ' basic listings');
				}
			}
		}, {
			namespace: 'advertise'
		});

		const $individualCost = $$('advertiseIndividualCost');
		const $individualLabel = $$('advertiseIndividualLabel');

		$$('advertiseIndividualCount').on('input', (e, el) => {
			const count = Number(el.value);

			$individualCost.text(59 + (count * 10));

			$individualLabel.text((count + 5) + ' promoted listings');
		}, {
			namespace: 'advertise'
		});

		$$('advertisePromotedSwitch').on('input', (e, el) => {
			$$('advertiseIndividual').toggle(! el.checked);
			$$('advertiseTeam').toggle(el.checked);
		}, {
			namespace: 'advertise'
		});

		const $teamCost = $$('advertiseTeamCost');
		const $teamLabel = $$('advertiseTeamLabel');

		$$('advertiseTeamCount').on('input', (e, el) => {
			const count = Number(el.value);

			if (count === 11) {
				$teamCost.text('—');
				$teamLabel.text('Contact us for volume pricing');

				return;
			}

			let total = 59 * Math.min(count, 5);
			let cap = count * 5;

			if (count > 5) {
				total += 45 * Math.min(count - 5, 5);
			}

			if (count > 10) {
				total += 40 * (count - 10);
			}

			$teamCost.text(LS.util.formatNumber(total));

			if (count >= 5) {
				cap *= 2;
			}

			$teamLabel.text(`${count} agents, ${cap} promoted listings`);
		}, {
			namespace: 'advertise'
		});
	},

	/**
	 * Initialize modals
	 */
	initModals() {
		$$('advertiseModal').on('click', (e, el) => {
			LS.util.view('advertise', el.dataset.view, template => {
				LS.modal.open({
					model: {
						title: el.dataset.title,
						content: template
					},
					width: 520
				});
			});
		}, {
			namespace: 'advertise'
		});
	}
});